export default __webpack_public_path__ + "static/media/G0110.Adult_Basic_Life_Support_Algorithm_2021_GS.1657102080000.6fac4ea3.jpg";